import Button from "components/base/Button";
import { useModals } from "ModalProvider";
import PackagingBaseInfoForm from "./PackagingBaseInfoForm";

const PackagingBaseInfoView = ({ gtmProjectId, packaging, disabled }) => {
  const basic = JSON.parse(packaging.basic);
  const modal = useModals();

  function editHandler() {
    modal.present({
      title: "Edit Packaging Basic Info",
      children: (
        <PackagingBaseInfoForm
          packagingId={packaging.id}
          originalBasicInfo={basic}
          onSave={modal.hide}
        />
      ),
    });
  }

  return (
    <div className="-mx-2 mt-2 whitespace-nowrap">
      <table>
        <tbody>
          <tr>
            <td className="text-orange-500 font-semibold">Jordan</td>
            <td className="w-full">
              {!disabled && (
                <div className="flex justify-end">
                  <Button onClick={editHandler}>Edit</Button>
                </div>
              )}
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Market:</td>
            <td>{basic.market}</td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Variants:</td>
            <td>{basic.variants}</td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Packaging Type:</td>
            <td>{basic.packagingType}</td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Use PDQ:</td>
            <td>{basic.usePDQ ? "Yes" : "No"}</td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Use Floor Display:</td>
            <td>
              {basic.useFloorDisplay ? "Yes" : "No"}
              {basic.useFloorDisplay ? ` - ${basic.floorDisplayType}` : null}
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>QTY / Carton:</td>
            <td>{basic.qtyPerCarton}</td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Trademark Name:</td>
            <td>{basic.trademark}</td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Age Grading:</td>
            <td>{basic.age}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PackagingBaseInfoView;
